module.exports = __webpack_public_path__ + "static/media/video.14b076ae.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/camry/video.mp4
// module id = 820
// module chunks = 0